import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Button, Grid, Box, TextField, InputAdornment } from '@mui/material'
import { Navbar } from '../../../component/shared/Navbar'
import { PageContainer } from '../../../component/styled/PageContainer'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import FileUploadIcon from '@mui/icons-material/FileUpload'
import RecipientTable from './RecipientTable'
import Breadcrumb from '../../../component/shared/Breadcrumb'

export const SalesRecipientPage = () => {
  const [search, setSearch] = useState('')
  const [openDialog, setOpenDialog] = useState(false)
  const [openImport, setOpenImport] = useState(false)
  const [editData, setEditData] = useState(null)

  const handleAdd = () => {
    setEditData(null)
    setOpenDialog(true)
  }

  const handleEdit = (data) => {
    setEditData(data)
    setOpenDialog(true)
  }

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Recipients</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Breadcrumb items={[{ label: 'Recipient' }]} />
            <Typography variant='h1'>Recipient</Typography>
          </Grid>
          <Grid item xs={12} display='flex' justifyContent='space-between' alignItems='center'>
            <TextField
              variant='outlined'
              size='small'
              placeholder='Search recipients...'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              sx={{ width: 300 }}
            />
            <Box display='flex' gap={2}>
              <Button
                variant='outlined'
                startIcon={<FileUploadIcon />}
                onClick={() => setOpenImport(true)}
              >
                IMPORT
              </Button>
              <Button
                variant='contained'
                color='primary'
                startIcon={<AddIcon />}
                onClick={handleAdd}
              >
                ADD RECIPIENT
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <RecipientTable
              search={search}
              onEdit={handleEdit}
              openDialog={openDialog}
              setOpenDialog={setOpenDialog}
              editData={editData}
              openImport={openImport}
              setOpenImport={setOpenImport}
            />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
